import { phone } from 'phone';

/**
 * Returns a boolean indicating whether the provided candidate contains only valid
 * characters for a phone number.
 *
 * @param   {String}  phoneNumber The phone number to validate
 * @returns {Boolean}
 */
export function containsOnlyValidPhoneNumberChars(phoneNumber) {
  var phoneNumberIsValidFor = function phoneNumberIsValidFor(regex) {
    return regex.test(phoneNumber);
  };

  // An optional "+" is allowed only at the start of the string.
  if (!phoneNumberIsValidFor(/^([+]?)[^+]+$/)) {
    return false;
  }

  // At most one set of parentheses, and they must be ordered and closed.
  if (!phoneNumberIsValidFor(/^(?:[+-.0-9/ ]*|[+-.0-9/ ]*\([+-.0-9/ ]*\)[+-.0-9/ ]*)$/)) {
    return false;
  }

  // At least 3 numbers must exist.
  if (!phoneNumberIsValidFor(/^(?:[^0-9]*[0-9]){3}.*/)) {
    return false;
  }

  // Only integers (0-9) and non-consecutive ( ) + - / ' ' (whitespace) are allowed.
  if (!phoneNumberIsValidFor(/^(?!.*([()+-/. ])\1)[0-9()+-/. ]+$/)) {
    return false;
  }
  return true;
}
export function formatPhoneNumber(value) {
  var _number$phoneNumber, _number$phoneNumber$r, _number$phoneNumber$r2;
  var number = phone(value);
  var match = (_number$phoneNumber = number.phoneNumber) === null || _number$phoneNumber === void 0 ? void 0 : (_number$phoneNumber$r = _number$phoneNumber.replace(number.countryCode, '')) === null || _number$phoneNumber$r === void 0 ? void 0 : (_number$phoneNumber$r2 = _number$phoneNumber$r.replace(/\D+/g, '')) === null || _number$phoneNumber$r2 === void 0 ? void 0 : _number$phoneNumber$r2.match(/(\d{3})(\d{3})(\d{4})/);
  if (match) {
    return "".concat(number.countryCode, " ") + "(".concat(match[1], ") ").concat(match[2], "-").concat(match[3]);
  } else {
    return value;
  }
}
//# sourceMappingURL=phoneNumberValidationUtil.js.map
